export const AUDIT_ROUTES = {
	audit: "/app/audit",
} as const;
